import { FC, ReactElement, useCallback, useState } from "react";
import { Link as RouterLink, Outlet, useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  Grid,
  Link,
  Stack,
  Typography,
} from "@mui/material";

import { SETTINGS_MENU } from "@/roles/sidebar-items";
import { ContactSupportModal } from "@/components";

const Settings: FC = (): ReactElement => {
  const { pathname } = useLocation();

  const isActivePath = useCallback(
    (path: string): boolean => {
      return pathname === path;
    },
    [pathname]
  );

  const [isContactSupportModalOpen, setIsContactSupportModalOpen] =
    useState(false);

  const handleOpenSupportModal = () => {
    setIsContactSupportModalOpen(true);
  };
  const handleCloseSupportModal = () => {
    setIsContactSupportModalOpen(false);
  };

  return (
    <>
      <Grid container py={1.25} spacing={3.75} flex={1}>
        <Grid item xs={12} sm={4}>
          <Card>
            <Box sx={{ pt: 3.75, pb: 2, px: 2.5 }}>
              <Box sx={{ width: "100%", px: 0.5 }}>
                <Typography
                  variant="h3"
                  fontWeight="500"
                  color="#030712"
                  fontSize="2rem"
                  lineHeight="2rem"
                  mb={0.5}
                >
                  Settings
                </Typography>
              </Box>
              <Stack
                sx={{
                  width: "100%",
                  mt: 3,
                }}
              >
                {SETTINGS_MENU.map(({ title, link, icon }) => (
                  <Link
                    component={RouterLink}
                    to={`/settings/${link}`}
                    key={title}
                    underline="none"
                  >
                    <Button
                      variant="text"
                      fullWidth
                      sx={{
                        width: "100%",
                        backgroundColor: isActivePath(`/settings/${link}`)
                          ? "rgba(11, 73, 75, 0.2)"
                          : "transparent",
                        p: 1.5,
                        borderRadius: 0.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        textAlign: "start",
                        gap: 2,
                        whiteSpace: "nowrap",
                      }}
                      startIcon={icon({
                        size: 20,
                        color: isActivePath(`/settings/${link}`)
                          ? "#0B494B"
                          : "#8E9494",
                      })}
                    >
                      <Typography
                        variant="body2"
                        color={
                          isActivePath(`/settings/${link}`)
                            ? "#0B494B"
                            : "#030712"
                        }
                        sx={{
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                      >
                        {title}
                      </Typography>
                    </Button>
                  </Link>
                ))}
              </Stack>
            </Box>
            <Box
              sx={{
                px: 3,
                py: 2.5,
                backgroundColor: "rgba(11, 73, 75, 0.1)",
                lineHeight: "20px",
              }}
            >
              <Typography variant="body2" color="#030712">
                Looking for Help?
              </Typography>
              <Typography variant="caption" color="grey.100">
                Fill out the{" "}
                <Link
                  component={RouterLink}
                  to="#"
                  sx={{
                    fontWeight: 600,
                  }}
                  onClick={handleOpenSupportModal}
                >
                  Contact Support Form
                </Link>
              </Typography>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={8}>
          <Card sx={{ height: "100%" }}>
            <Outlet />
          </Card>
        </Grid>
      </Grid>
      {/*Contact Support Modal*/}
      <ContactSupportModal
        open={isContactSupportModalOpen}
        onClose={handleCloseSupportModal}
      />
    </>
  );
};

export default Settings;
